
function get(url){
     
      return  new Promise(function(resolve, reject) {
        var xhr = new XMLHttpRequest();
      xhr.addEventListener("load", function(){resolve(this.responseText)});
      xhr.open("GET", url);
      xhr.send();

      });
      
}


function post(url,data){
    return  new Promise(function(resolve, reject) {
        var xhr = new XMLHttpRequest();
     
      xhr.addEventListener("load", function(){resolve(this.responseText)});
      xhr.open("POST", url);
      xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      xhr.send(JSON.stringify(data));

      });


}


export default {
    get,
    post
}